export default {
  getOperadores: state => state.operadores,
}
